import styled from 'styled-components'
import Box from '@mui/material/Box'

export const CenteredBox = styled(Box)`
display: flex;
align-items: center;
justify-content: center;
`

export const CartBox = styled(Box)`
display: flex;
align-items: center;
justify-content: space-between;
margin-bottom: 10px;
`